import { Component, inject } from '@angular/core';
import { VariableGroupService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  VariableGroupCreateDto,
  VariableGroupDto,
  VariableGroupExcelDownloadDto,
  VariableGroupUpdateDto,
} from '../proxy/controlling/dtos/variable-group';
import { VARIABLEGROUP_CONFIG, VARIABLEGROUP_FIELDS } from './variable-group.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-variable-group',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, VariableGroupService, ConfirmationService],
  templateUrl: './variable-group.html',
  styleUrl: './variable-group.scss',
})
export class VariableGroup extends BaseCrudComponent<
  VariableGroupDto,
  VariableGroupCreateDto,
  VariableGroupUpdateDto,
  VariableGroupExcelDownloadDto
> {
  service = inject(VariableGroupService);
  config = VARIABLEGROUP_CONFIG;
  fields = VARIABLEGROUP_FIELDS;

  protected prepareUpdateDto(data: any, selected: VariableGroupDto): VariableGroupUpdateDto {
    return {
      name: data.name,
      code: data.code,
      tariffsModuleId: data.tariffsModuleId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'VariableGroup';
  }
}
